import React from 'react';

interface ManutencaoProps {
    titulo?: string;
    mensagem?: string;
}

const Manutencao: React.FC<ManutencaoProps> = ({ 
    titulo = "Página em Manutenção", 
    mensagem = "Estamos atualizando esta parte do Espaço Digital para oferecer a você uma experiência ainda melhor. Voltaremos em breve!" 
}) => {
    
    const handleBack = () => {
        window.history.back();
    };

    return (
        <div className="manutencao-container">
            <div className="manutencao-card">
                <div className="manutencao-icon-wrapper">
                    <i className="fa fa-tools manutencao-icon"></i>
                </div>
                <h1 className="manutencao-title">{titulo}</h1>
                <p className="manutencao-text">
                    {mensagem}
                </p>
                <button className="manutencao-button" onClick={handleBack}>
                    <i className="fa fa-arrow-left"></i> Voltar Agora
                </button>
            </div>
        </div>
    );
};

export default Manutencao;
